import React from "react";
import { ResponsiveBar } from "@nivo/bar";
import { red } from "@mui/material/colors";

const BarGraph = () => {
  const data = [
    {
      "country": "Universty",
      "university": 50,
    },
    {
      "country": "Universty2",
      "university": 50,
    },
    {
      "country": "Universty3",
      "university": 40,
      
    },
    {
      "country": "Universty4",
      "university": 60,
    },
    {
      "country": "Universty5",
      "university": 70,
    },
    {
      "country": "Universty6",
      "university": 20,
    },
    // {
    //   "country": "AE",
    //   "hot dog": 45,
    //   "hot dogColor": "hsl(91, 70%, 50%)",
    //   "burger": 99,
    //   "burgerColor": "hsl(139, 70%, 50%)",
    //   "sandwich": 47,
    //   "sandwichColor": "hsl(178, 70%, 50%)",
    //   "kebab": 17,
    //   "kebabColor": "hsl(29, 70%, 50%)",
    //   "fries": 65,
    //   "friesColor": "hsl(289, 70%, 50%)",
    //   "donut": 21,
    //   "donutColor": "hsl(346, 70%, 50%)"
    // },
    // {
    //   "country": "AF",
    //   "hot dog": 184,
    //   "hot dogColor": "hsl(340, 70%, 50%)",
    //   "burger": 194,
    //   "burgerColor": "hsl(308, 70%, 50%)",
    //   "sandwich": 189,
    //   "sandwichColor": "hsl(197, 70%, 50%)",
    //   "kebab": 33,
    //   "kebabColor": "hsl(256, 70%, 50%)",
    //   "fries": 123,
    //   "friesColor": "hsl(254, 70%, 50%)",
    //   "donut": 104,
    //   "donutColor": "hsl(74, 70%, 50%)"
    // },
    // {
    //   "country": "AG",
    //   "hot dog": 148,
    //   "hot dogColor": "hsl(100, 70%, 50%)",
    //   "burger": 19,
    //   "burgerColor": "hsl(283, 70%, 50%)",
    //   "sandwich": 127,
    //   "sandwichColor": "hsl(135, 70%, 50%)",
    //   "kebab": 170,
    //   "kebabColor": "hsl(146, 70%, 50%)",
    //   "fries": 168,
    //   "friesColor": "hsl(183, 70%, 50%)",
    //   "donut": 197,
    //   "donutColor": "hsl(267, 70%, 50%)"
    // },
    // {
    //   "country": "AI",
    //   "hot dog": 147,
    //   "hot dogColor": "hsl(61, 70%, 50%)",
    //   "burger": 43,
    //   "burgerColor": "hsl(319, 70%, 50%)",
    //   "sandwich": 15,
    //   "sandwichColor": "hsl(7, 70%, 50%)",
    //   "kebab": 94,
    //   "kebabColor": "hsl(51, 70%, 50%)",
    //   "fries": 126,
    //   "friesColor": "hsl(147, 70%, 50%)",
    //   "donut": 33,
    //   "donutColor": "hsl(191, 70%, 50%)"
    // },
    // {
    //   "country": "AL",
    //   "hot dog": 62,
    //   "hot dogColor": "hsl(132, 70%, 50%)",
    //   "burger": 69,
    //   "burgerColor": "hsl(325, 70%, 50%)",
    //   "sandwich": 28,
    //   "sandwichColor": "hsl(175, 70%, 50%)",
    //   "kebab": 139,
    //   "kebabColor": "hsl(211, 70%, 50%)",
    //   "fries": 79,
    //   "friesColor": "hsl(259, 70%, 50%)",
    //   "donut": 12,
    //   "donutColor": "hsl(151, 70%, 50%)"
    // },
    // {
    //   "country": "AM",
    //   "hot dog": 114,
    //   "hot dogColor": "hsl(76, 70%, 50%)",
    //   "burger": 18,
    //   "burgerColor": "hsl(99, 70%, 50%)",
    //   "sandwich": 168,
    //   "sandwichColor": "hsl(354, 70%, 50%)",
    //   "kebab": 197,
    //   "kebabColor": "hsl(347, 70%, 50%)",
    //   "fries": 161,
    //   "friesColor": "hsl(41, 70%, 50%)",
    //   "donut": 146,
    //   "donutColor": "hsl(247, 70%, 50%)"
    // }
  ];

  return (
    <div style={{ height: "400px" }}>
      <ResponsiveBar
        data={data}
        keys={["university"]}
        indexBy="country"
        margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
        padding={0.3}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={{ scheme: "nivo" }}
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "#38bcb2",
            size: 4,
            padding: 1,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "#eed312",
            rotation: -45,
            lineWidth: 6,
            spacing: 10,
          },
        ]}
        fill={[
          {
            match: {
              id: "fries",
            },
            id: "dots",
          },
          {
            match: {
              id: "sandwich",
            },
            id: "lines",
          },
        ]}
        borderColor={{
          from: "color",
          modifiers: [["darker", 1.6]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "University",
          legendPosition: "middle",
          legendOffset: 32,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          // legend: 'food',
          legendPosition: "middle",
          legendOffset: -40,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: "color",
          modifiers: [["darker", 1.6]],
        }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom-right",
            direction: "column",
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
        role="application"
        ariaLabel="Nivo bar chart demo"
        barAriaLabel={function (e) {
          return (
            e.id + ": " + e.formattedValue + " in country: " + e.indexValue
          );
        }}
      />
    </div>
  );
};

export default BarGraph;
